import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";
import BrandSelector from "../views/BrandSelector.vue";
import WechatAuth from "../views/WechatAuth.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: index,
  },
  {
    path: "/brand-selector",
    name: "brandSelector",
    component: BrandSelector,
  },
  {
    path: "/wechat-auth",
    name: "wechatAuth",
    component: WechatAuth,
  },
];

const router = new VueRouter({
  mode: "history", // 可选 history/hash 模式
  base: "/h5/",
  routes,
});

export default router;
